import DgSelect from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgSelect.install = function (Vue) {
  Vue.component(DgSelect.name, DgSelect)
}
export default DgSelect

export { DgSelect }